import { type UseTrackClickedCanvasNullStateSuggestionParams } from '@air/analytics';
import { FileStackIcon, type IconComponent, SquarePlayIcon, SquareSlashIcon } from '@air/design-icons';

export type CanvasSuggestionId = UseTrackClickedCanvasNullStateSuggestionParams['suggestion_id'];

export type CanvasSuggestion = {
  icon: IconComponent;
  id: CanvasSuggestionId;
  label: string;
  message: string;
};

export const RUN_SKILL_SUGGESTION: CanvasSuggestion = {
  icon: SquareSlashIcon,
  id: 'run_skill',
  label: 'Type, or / to explore skills',
  message: '/',
};

export const SMART_RESIZE_SUGGESTION: CanvasSuggestion = {
  icon: FileStackIcon,
  id: 'smart_resize',
  label: 'Make social variants',
  message:
    'Generate social variants of this image for:\n• LinkedIn Feed Landscape (1200 × 628)\n• Instagram Feed Portrait (1080 × 1350)\n• YouTube Thumbnail (1280 × 720)',
};

export const CONVERT_IMAGE_SUGGESTION: CanvasSuggestion = {
  icon: SquarePlayIcon,
  id: 'convert_image',
  label: 'Animate',
  message:
    'Turn this image into a short video. Add a subtle motion effect — like a slow zoom or parallax — that feels cinematic, not cheesy. Keep it about 4 seconds.\n\nLet me know if you need more detail.',
};

export const IMAGE_SUGGESTIONS: CanvasSuggestion[] = [
  SMART_RESIZE_SUGGESTION,
  CONVERT_IMAGE_SUGGESTION,
  RUN_SKILL_SUGGESTION,
];

export const EMPTY_CANVAS_SUGGESTIONS: CanvasSuggestion[] = [];
